module.exports = __webpack_public_path__ + "img/right.b8ec98ff.png";